import React from 'react';
import Button from './Button';

/**
 * A component that showcases all button variations for demonstration
 */
const ButtonExamples = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-sm">
      <h2 className="text-2xl font-semibold mb-6 text-hooray-dark-text">Hooray Power Button Examples</h2>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 text-hooray-dark-text">CTA Buttons (hover to see effect)</h3>
        <div className="flex flex-wrap gap-4">
          <Button variant="cta" size="md">Download Brochure</Button>
          <Button variant="cta" size="lg">Book a Site Visit</Button>
        </div>
        <p className="mt-4 text-sm text-gray-500">These buttons match the style from the Hooray Power website, with coral color that changes to yellow/peach on hover.</p>
      </div>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 text-hooray-dark-text">CTA Secondary Buttons</h3>
        <div className="flex flex-wrap items-center gap-4 p-4 bg-hooray-red rounded-lg">
          <Button variant="ctaSecondary" size="sm">Small CTA Secondary</Button>
          <Button variant="ctaSecondary" size="md">Medium CTA Secondary</Button>
          <Button variant="ctaSecondary" size="lg">Large CTA Secondary</Button>
        </div>
        <p className="mt-4 text-sm text-gray-500">Use this variant for buttons placed on dark or colored backgrounds (like the header) where the primary CTA would blend in. Default is white background, red text. Hovers to yellow background, red text.</p>
      </div>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 text-hooray-dark-text">CTA Button Sizes</h3>
        <div className="flex flex-wrap items-center gap-4">
          <Button variant="cta" size="sm">Small CTA</Button>
          <Button variant="cta" size="md">Medium CTA</Button>
          <Button variant="cta" size="lg">Large CTA</Button>
        </div>
      </div>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 text-hooray-dark-text">Other Button Variants (For Reference)</h3>
        <div className="flex flex-wrap gap-4">
          <Button variant="primary">Primary Button</Button>
          <Button variant="secondary">Secondary Button</Button>
          <Button variant="outline">Outline Button</Button>
          <Button variant="text">Text Button</Button>
        </div>
        <p className="mt-2 text-sm text-gray-500 font-medium">Note: We're focusing on using CTA buttons for our application.</p>
      </div>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 text-hooray-dark-text">Disabled CTA Button</h3>
        <div className="flex flex-wrap gap-4">
          <Button variant="cta" disabled>Disabled CTA Button</Button>
        </div>
      </div>
      
      <div className="mb-8">
        <h3 className="text-lg font-medium mb-4 text-hooray-dark-text">CTA Links</h3>
        <div className="flex flex-wrap gap-4">
          <Button variant="cta" to="/">Internal Link</Button>
          <Button variant="cta" href="https://hooraypower.co.za">External Link</Button>
        </div>
      </div>
    </div>
  );
};

export default ButtonExamples; 